import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../../services/authService';
import {
  PageContainer,
  Card,
  Title,
  Subtitle,
  Field,
  SubmitButton,
  SwitchLink,
  ErrorBox,
  SuccessBox,
} from './auth.styles';

const ResetPassword = () => {
  const navigate = useNavigate();

  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const isSubmitting = status === 'loading';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!resetCode || !newPassword) {
      setMessage('Todos os campos são obrigatórios');
      return;
    }

    if (resetCode.length !== 6 || isNaN(resetCode)) {
      setMessage('O código deve ter exatamente 6 dígitos');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('As senhas não coincidem');
      return;
    }

    if (newPassword.length < 8) {
      setMessage('A senha deve ter no mínimo 8 caracteres');
      return;
    }

    setStatus('loading');
    try {
      // Pegar email do localStorage (salvo quando enviou o código)
      const emailSalvo = localStorage.getItem('resetEmail') || '';
      await authService.resetPassword(emailSalvo, resetCode, newPassword);
      setStatus('success');
      setMessage('Senha alterada com sucesso! Você será redirecionado para a página de login...');
      localStorage.removeItem('resetEmail');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Falha ao resetar a senha. O código pode ter expirado.');
    }
  };

  return (
    <PageContainer>
      <Card onSubmit={handleSubmit} noValidate>
        <Title>Resetar Senha</Title>
        <Subtitle>Digite o código recebido no seu email</Subtitle>

        {message && (
          status === 'success' ? (
            <SuccessBox>{message}</SuccessBox>
          ) : (
            <ErrorBox>{message}</ErrorBox>
          )
        )}

        <Field>
          Código de Recuperação
          <input
            type="text"
            placeholder="6 dígitos"
            value={resetCode}
            onChange={(e) => setResetCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            required
            maxLength={6}
            disabled={isSubmitting || status === 'success'}
          />
        </Field>

        <Field>
          Nova Senha
          <input
            type="password"
            placeholder="Mínimo 8 caracteres"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            disabled={isSubmitting || status === 'success'}
          />
        </Field>

        <Field>
          Confirmar Senha
          <input
            type="password"
            placeholder="Repita a nova senha"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={8}
            disabled={isSubmitting || status === 'success'}
          />
        </Field>

        <SubmitButton type="submit" disabled={isSubmitting || status === 'success'}>
          {isSubmitting ? 'Processando...' : 'Alterar Senha'}
        </SubmitButton>

        <SwitchLink style={{ marginTop: '16px' }}>
          Volte para <Link to="/login">entrar</Link> novamente
        </SwitchLink>
      </Card>
    </PageContainer>
  );
};

export default ResetPassword;
